import {ACTION} from "../constants";

export default function sipInputValue(state = {}, action) {
    switch (action.type) {
        case ACTION.SAVE_SIP:
            return {...state, homeCalcSIP: action.data};
        default:
            return state;
    }
}


export let saveSIP = (data) => {
    return {
        type: ACTION.SAVE_SIP,
        data: data,
    };
}
